import axios from '@/api';

export default {
  async checkEmailIsUse(context, { email = null }) {
    return await axios
      .post('lookup/checkemail', {
        items: [
          {
            emailAddress: email,
          },
        ],
      })
      .then(response => response.data)
      .then(response =>
        response.items.length > 0 ? response.items[0] : { inUse: false }
      )
      .then(response => response.inUse);
  },
  async uploadMedias(context, { file }) {
    var formData = new FormData();
    formData.append('file', file);

    return await axios
      .post('upload', formData)
      .then(response => response.data)
      .then(response => (response.items.length > 0 ? response.items[0] : null));
  },
};
